import { z } from 'zod';

import { CatalogItemStatusSchema } from '../services/catalog-item-status.schema.js';

export const ChangeKitStatusBodySchema = z.object({
  status: CatalogItemStatusSchema,
  reason: z.string().trim().max(500).optional(),
});

export type ChangeKitStatusBody = z.infer<typeof ChangeKitStatusBodySchema>;
